export const businessHours = [
  { day: 'Monday', hours: '11:00 AM - 10:00 PM' },
  { day: 'Tuesday', hours: '11:00 AM - 10:00 PM' },
  { day: 'Wednesday', hours: '11:00 AM - 10:00 PM' },
  { day: 'Thursday', hours: '11:00 AM - 10:00 PM' },
  { day: 'Friday', hours: '11:00 AM - 11:00 PM' },
  { day: 'Saturday', hours: '10:00 AM - 11:00 PM' },
  { day: 'Sunday', hours: '10:00 AM - 9:00 PM' }
];